import type { JSX, ReactNode } from 'react';

/** Shared My Data category chrome: ownership is part of every stored-data category. */
export interface MyDataCategoryCardProps {
  readonly heading: string;
  readonly ownership: string;
  readonly children: ReactNode;
}

export function MyDataCategoryCard({
  heading,
  ownership,
  children,
}: MyDataCategoryCardProps): JSX.Element {
  return (
    <section
      aria-label={heading}
      className="flex flex-col overflow-hidden rounded-2xl border border-border bg-card"
    >
      <div className="border-b border-border px-4 py-3">
        <h4 className="text-sm font-semibold text-foreground">{heading}</h4>
        <p className="mt-0.5 text-xs text-muted-foreground">{ownership}</p>
      </div>
      {children}
    </section>
  );
}

export interface MyDataFieldProps {
  readonly label: string;
  readonly value: string;
}

export function MyDataField({ label, value }: MyDataFieldProps): JSX.Element {
  return (
    <div className="border-b border-border px-4 py-3 last:border-b-0">
      <dt className="text-sm font-medium text-muted-foreground">{label}</dt>
      <dd className="mt-1 text-sm text-foreground">{value}</dd>
    </div>
  );
}

export function MyDataEmptyNote({ children }: { readonly children: ReactNode }): JSX.Element {
  return <p className="px-4 py-3 text-sm text-muted-foreground">{children}</p>;
}
